<template>
  <div class="fields-content">
    <header-info
      :sheet="sheet"
      :mainField="mainField"
      :btnArray="btnArray"
      @click.native="$emit('openSetting', { type: 'btnArray' })"
    ></header-info>
    <overview-info
      :overview-fields="overviewFields"
      editing
      @click.native="$emit('openSetting', { type: 'overviewInfo' })"
      from="sheetBacked"
    ></overview-info>
    <progress-info
      from="sheetBacked"
      :progress="progress"
      :control-map="controlMap"
      @click.native="$emit('openSetting', { type: 'progress' })"
    ></progress-info>
    <div class="fields-group-wrap">
      <div class="title">详细信息</div>
      <draggable class="group-wrap" group="fields-group" v-model="fieldsGroup" :animation="100">
        <fields-group
          v-for="(group, index) in fieldsGroup"
          v-on="$listeners"
          :key="group.id"
          :allFields="allFields"
          :group="group"
          :activeControlCid="activeControl | getCid"
          :can-delete="fieldsGroup.length > 1"
          @delete="fieldsGroup.splice(index, 1)"
        ></fields-group>
      </draggable>
      <div class="group-wrap">
        <system-fields-group
          v-on="$listeners"
          :hidden-cids="hiddenCids"
          :activeControlCid="activeControl | getCid"
          @hideSystemField="hideSystemField"
        ></system-fields-group>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import FieldsGroup from "./fields-group"
import HeaderInfo from "./header-info"
import OverviewInfo from "./overview-info"
import ProgressInfo from "@/views/Backend/AdminEdit/Sheet/Field/fields-content/progress-info"
import SystemFieldsGroup from "@/views/Backend/AdminEdit/Sheet/Field/fields-content/system-fields-group"

export default {
  name: "fields-content",
  components: {
    SystemFieldsGroup,
    ProgressInfo,
    draggable,
    FieldsGroup,
    HeaderInfo,
    OverviewInfo
  },
  props: {
    sheet: Object,
    mainField: Object,
    activeControl: Object,
    btnArray: Array,
    overviewFields: Array,
    progress: Object,
    allFields: Array
  },
  computed: {
    controlMap() {
      let result = {}
      this.sheet.data.controls?.forEach(control => (result[control._cid] = control))
      return result
    }
  },
  watch: {
    fieldsGroup: {
      handler() {
        this.hasInit && this.$emit("update", { dataType: "fieldsGroup", data: this.fieldsGroup })
      },
      deep: true
    }
  },
  data() {
    return {
      hasInit: false,
      controls: [],
      fieldsGroup: [],
      hiddenCids: []
    }
  },
  filters: {
    getCid(control) {
      if (!control) return ""
      return control._cid || control.code
    }
  },
  methods: {
    init(fieldsGroup, hiddenCids) {
      this.hasInit = false
      this.fieldsGroup = fieldsGroup
      this.hiddenCids = hiddenCids
      this.$nextTick(() => (this.hasInit = true))
    },
    hideSystemField(field, isShow) {
      if (isShow) this.hiddenCids = this.hiddenCids.filter(cid => field._cid !== cid)
      else this.hiddenCids.push(field._cid)
      this.$emit("update", { dataType: "systemFields", data: this.hiddenCids })
    }
  }
}
</script>

<style lang="scss" scoped>
.fields-content {
  border-right: 1px solid #eaeaea;
  padding: 16px;
  .overview-info {
    margin-top: 12px;
  }
  .fields-group-wrap {
    border: 1px solid #dee1e6;
    margin: 0 0 12px 0;
    border-radius: 4px;
    padding: 14px 0;
    .title {
      font-size: 15px;
      padding-left: 14px;
      &::before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 12px;
        background-color: #ff8000;
        margin-right: 4px;
      }
    }
    .group-wrap ::v-deep {
      .fields-group {
        margin: 6px;
        padding: 10px;
        user-select: none;
        font-size: 13px;
        box-sizing: border-box;
        cursor: move;
        border-radius: 4px;
        border: 1px solid transparent;
        position: relative;

        &:hover {
          border-style: dashed;
          border-color: #ff8000;

          .delete-group {
            visibility: visible;
          }
        }
      }
      .system-fields-group {
        margin: 6px;
        padding: 10px;
        user-select: none;
        font-size: 13px;
        box-sizing: border-box;
        cursor: move;
        border-radius: 4px;
        border: 1px solid transparent;
        position: relative;

        &:hover {
          border-style: dashed;
          border-color: #ff8000;
        }
      }
    }
  }
}
</style>
